import moment from 'moment';
import { toast } from 'react-toastify';

export const PHONE_NUMBER_REGEX = /^\+44\d{10}$/;

export const STATUS_OPTIONS_ADMIN = [
  { label: 'All (default)', value: 'default' },
  { label: 'Pending Review', value: 'pending-review' },
  { label: 'Upcoming', value: 'upcoming' },
  { label: 'In Progress', value: 'in-progress' },
  { label: 'Rejected', value: 'rejected' },
  { label: 'Cancelled', value: 'cancelled' },
  { label: 'Failed', value: 'failed' },
  { label: 'Wrapping Up', value: 'wrapping-up' },
  { label: 'Completed', value: 'completed' },
];
export const statusModalArray = {
  upcoming: {
    message: 'To revert to this Job Status please call your line manager.',
    canSelect: false,
  },
  'in-progress': {
    message: 'Are you currently on route to your "1st destination?',
    canSelect: true,
  },
  cancelled: {
    message: 'To cancel this job please call your line manager.',
    canSelect: false,
  },
  failed: {
    message: 'To fail this job please call your line manager.',
    canSelect: false,
  },
  'wrapping-up': {
    message: 'Have you delivered your goods at your last destination?',
    canSelect: true,
  },
};
export const STATUS_OPTIONS_EMPLOYEE = [
  { label: 'All (default)', value: 'default' },
  { label: 'Upcoming', value: 'upcoming' },
  { label: 'In Progress', value: 'in-progress' },
  { label: 'Cancelled', value: 'cancelled' },
  { label: 'Failed', value: 'failed' },
  { label: 'Wrapping Up', value: 'wrapping-up' },
  { label: 'Completed', value: 'completed' },
];
export const DRIVER_STATUS_OPTIONS = [
  { label: 'Upcoming', value: 'upcoming', changeColor: true },
  { label: 'In Progress', value: 'in-progress' },
  { label: 'Cancelled', value: 'cancelled', changeColor: true },
  { label: 'Failed', value: 'failed', changeColor: true },
  { label: 'Wrapping Up', value: 'wrapping-up' },
];
export const constants = {
  authToken: 'token',
  pending: 'PENDING',
  joined: 'JOINED',
};
export const PESSENGER_RADIO = [
  { label: '0', value: 0 },
  { label: '1', value: 1 },
  { label: '2', value: 2 },
];
export const roleArray = [
  { value: '', label: 'Choose role' },
  { value: 'ADMIN', label: 'Admin' },
  { value: 'EMPLOYEE', label: 'Employee' },
];

export const userStatusArray = [
  { value: '', label: 'Choose status' },
  { value: 'PENDING', label: 'PENDING' },
  { value: 'ACTIVE', label: 'ACTIVE' },
  { value: 'DORMANT', label: 'DORMANT' },
  { value: 'DISMISSED', label: 'DISMISSED' },
];
export const VAN_SIZE_OPTIONS = [
  { value: 'SWB', label: 'SWB' },
  { value: 'MWB', label: 'MWB' },
  { value: 'LWB', label: 'LWB' },
  { value: 'XLWB', label: 'XLWB' },
];

export const booleanArray = [
  { value: '', label: 'Choose value' },
  { value: true, label: 'True' },
  { value: false, label: 'False' },
];

export const showSuccessTost = (msg) => {
  toast.success(msg, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    progressStyle: { background: '#2266D1' },
  });
};

export const showErrorTost = (msg) => {
  toast.error(msg, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const getQueryString = (params) => {
  return Object.keys(params)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
};

export const showDate = (date) => moment(date).format('ddd-DD-MMM-YYYY');
export const showTime = (date) => moment(date).format('LT');

export const removeEmptyKeys = (obj) =>
  Object.entries(obj).reduce(
    (acc, [key, value]) =>
      value !== null &&
      value !== undefined &&
      value !== '' &&
      !(Array.isArray(value) && value.length === 0) &&
      !(typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0)
        ? { ...acc, [key]: value }
        : acc,
    {}
  );
